export const supportedLanguages = ['en', 'fr'];
